MS = window.MS || {};

(function($) {
    $body = $('body');

    MS.sultrysalt_recipe_transporter = {
      init: function () {
        this.$contentWrapper = $('.ms_ss_article');
        this.$content = $('.ms_ss_article__content');
      },
      loadRecipe: function (postID) {
        var that = this;
        $body.addClass('recipe-busy');

        // Get recipe content HTML
        $.get('/ajax/sultry_salt_recipe_content?post_ID=' + postID)
        .done(function (data) {
          that.$content.html(data);

          // Track analytics page view
          if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
              event: 'SultrySaltPageView',
              sultrysaltUrl: document.location.href,
              sultrysaltPathname: document.location.pathname
            });
          }

        })
        .fail(function (error) {
          console.log('error',error);
        })
        .always(function () {
          MS.sultrysalt.initilializeDynamicModules();
          $body.addClass('recipe-content-loaded').removeClass('recipe-busy');
        });
      }
    };
})(jQuery);
